import DetailedDailyProfit from './components/DetailedDailyProfit/DetailedDailyProfit'

const DailyProfit = () => {
  return <DetailedDailyProfit />
}

export default DailyProfit
